import { CancelTokenSource } from 'axios';
import axios from 'services/http';
import {
  LabImportFileRequest,
  LabImportResponse,
  LabProcedureImportRequest,
  LabProcedureResultDto
} from 'ts-types/api.types';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/lab-import`;

export const labImportFromFile = (values: Partial<LabImportFileRequest>, source: CancelTokenSource)
    : Promise<Array<LabProcedureResultDto>> => {

  let bodyFormData = new FormData();
  Object.keys(values).forEach((key) => {
    let value = values[key as keyof LabImportFileRequest];

    if (value) {
      if (typeof value === "number") {
        //@ts-ignore
        value = value.toString();
      }
      //@ts-ignore
      bodyFormData.append(key, value);
    }

  });

  return axios
      .post(`${apiUri}`, bodyFormData, {cancelToken: source.token})
      .then(response => response.data);
};


export const importLabProcedures = (request: Partial<LabProcedureImportRequest>,
                                    source: CancelTokenSource): Promise<LabImportResponse> => {
  return axios
      .post(`${apiUri}/import-procedures`, request, {cancelToken: source.token})
      .then(response => response.data)
};
